import React from "react";
import "./PaymentSuccess.css";
import { Link } from "react-router-dom";
import illustration from "./backgrounds/2/Dayflow - Success Notification.png";

function PaymentSuccess(props) {
	return (
		<div className="payment-success-wrapper">
			<div className="payment-success-container">
                <img src={illustration} width={150} height={150} />
				<p>
					{" "}
					Congratulations! You have successfully upgraded to The Feedgram
					premium!
				</p>
				<div className="back-home-link">
					<Link to="/home">Back to Home</Link>
				</div>
			</div>
		</div>
	);
}

export default PaymentSuccess;
